import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    IconButton,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { useAddCategoryMutation } from "../../store/services/categoriesService";
import { Icons } from "../../assets/Icons/Svgs";

const labelStyle = {
    fontFamily: "PSBo",
    fontSize: 15,
    color: "#333",
    mb: 0.5,
};

const AddCategoryDialog = ({ open, onClose }) => {
    const words = useSelector((state) => state.authReducer.words);

    const [name, setName] = useState('');
    const [arName, setArName] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [addCategory, { isLoading }] = useAddCategoryMutation();



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // && file.type === "image/png"
        if (file) {
            setSelectedFile(file);
        } else {
            toast.error("Please upload a valid PNG file.");
        }
    };

    const handleSubmit = async () => {
        if (!name) {
            toast.error("Please enter category name");
            return;
        }

        const formData = new FormData();
        formData.append("name", name);
        formData.append("ar_name", arName);

        if (selectedFile) {
            formData.append("image", selectedFile);
        }
        try {
            const response = await addCategory(formData).unwrap();
            if (response.status === "1") {
                toast.success("Category added successfully!");
                onClose(); // Close the dialog on success
            } else {
                toast.error(response.error ?? "Failed to add category. Please try again.");
            }
        } catch (error) {
            console.error("Error adding category:", error);
            toast.error("An error occurred. Please try again.");
        }
    };

    return (
        <>



            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <Loader open={isLoading} />

                <DialogTitle sx={{ fontFamily: "PSBo", fontSize: 18, color: "#333" }}>
                    {words["Add category"]}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} display="flex" flexDirection="row" justifyContent="space-between">
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                                <Box
                                    sx={{
                                        width: "95px",
                                        height: "95px",
                                        borderRadius: "50px",
                                        border: "1px dashed #ccc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        textAlign: "center",
                                        color: "#999",
                                        backgroundColor: "#E6E6E6",
                                        cursor: "pointer",
                                        position: "relative",
                                    }}
                                    onClick={() => document.getElementById("profileImageUpload").click()} // Triggers the hidden input
                                >
                                    {selectedFile ? (
                                        <img
                                            src={URL.createObjectURL(selectedFile)} // Display the uploaded image preview
                                            alt="Profile Preview"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <Icons.imageUplaodIcon />
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        ml: 1,
                                    }}
                                >
                                    <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                        Upload the Image
                                    </Typography>
                                    <Typography sx={{ fontFamily: "PMe", fontSize: 14, color: "#999" }}>
                                        150x150 pixel
                                    </Typography>
                                </Box>
                            </Box>

                            <input
                                type="file"
                                id="profileImageUpload"
                                accept=".png,.jpg,.jpeg,"

                                // accept="image/png"
                                onChange={handleFileChange}
                                style={{ display: "none" }} // Hidden file input
                            />

                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Name"]}*</Typography>
                            <TextField
                                fullWidth
                                name="name"
                                value={name}
                                onChange={(v) => setName(v.target.value)}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={labelStyle}>{words["Arabic Name"]}*</Typography>
                            <TextField
                                fullWidth
                                name="ar_name"
                                value={arName}
                                onChange={(v) => setArName(v.target.value)}
                                required
                            />
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={{
                            borderRadius: "20px",
                            fontSize: 12,
                            padding: "8px 16px",
                            textTransform: "none",
                            fontFamily: 'PMe'
                        }}
                    >
                        {words["Cancel"]}
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={isLoading}
                        sx={{
                            backgroundColor: '#CD454A',
                            fontSize: 12,
                            color: "white",
                            borderRadius: "20px",
                            padding: "8px 26px",
                            textTransform: "none",
                            fontFamily: 'PMe'
                        }}
                    >
                        {isLoading ? "Submitting..." : words["Save"]}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AddCategoryDialog;